<nz-tabset>
	<nz-tab nzTitle="Timeline">
		<app-timeline-showcase></app-timeline-showcase>
	</nz-tab>
	<nz-tab nzTitle="Buttons">
		<app-button-showcase></app-button-showcase>
	</nz-tab>
	<nz-tab nzTitle="Button - Funktionen">
		<app-button-function-showcase></app-button-function-showcase>
	</nz-tab>
	<nz-tab nzTitle="WFS Status Buttons">
		<h3>Reine Übersicht ohne Tooltip</h3>
		<span>Signiert</span>
		<app-buttons-wfs-status [status]="'signiert'"></app-buttons-wfs-status>
		<span>Abgenommen</span>
		<app-buttons-wfs-status [status]="'abgenommen'"></app-buttons-wfs-status>
		<span>Offene Query</span>
		<app-buttons-wfs-status [status]="'offene query'"></app-buttons-wfs-status>
		<span>Bearbeite Query</span>
		<app-buttons-wfs-status [status]="'bearbeitete query'"></app-buttons-wfs-status>
		<span>In Bearbeitung</span>
		<app-buttons-wfs-status [status]="'in bearbeitung'"></app-buttons-wfs-status>
		<span>Eingabe vollständig</span>
		<app-buttons-wfs-status [status]="'eingabe vollständig'"></app-buttons-wfs-status>
		<span>Nicht begonnen</span>
		<app-buttons-wfs-status [status]="'nicht begonnen'"></app-buttons-wfs-status>
		<span>Nicht verfügbar</span>
		<app-buttons-wfs-status [status]="'nicht verfügbar'"></app-buttons-wfs-status>
	</nz-tab>
	<nz-tab nzTitle="Formulare">
		<div nz-col nzSpan="24">
			<div nz-row [nzGutter]="[16, 16]">
				<div nz-col nzSpan="12">
					<nz-card nzTitle="Gesperrtes Formular">
						<app-formular-showcase></app-formular-showcase>
					</nz-card>
				</div>
				<div nz-col nzSpan="12">
					<nz-card nzTitle="Formulare Bearbeiten - (halbe Breite, nicht responsive)">
						<app-formular-showcase [editFormular]="true"></app-formular-showcase>
					</nz-card>
				</div>
			</div>
		</div>
	</nz-tab>
	<nz-tab nzTitle="Modale">
		<div nz-col nzSpan="24">
			<app-modal-showcase></app-modal-showcase>
		</div>
	</nz-tab>
	<nz-tab nzTitle="Tabellen">
			<div nz-col nzSpan="12">
				<nz-card nzTitle="Tabellen mit Button - (halbe Breite, nicht responsive)">
					<app-table-showcase></app-table-showcase>
				</nz-card>
			</div>
	</nz-tab>
	<nz-tab nzTitle="Workflow">
		<nz-row [nzGutter]="[16, 6]">

			<div nz-col nzSpan="24">
				<nz-card nzTitle="Workflow-Detail (Fragebogen)">
					<app-workflow-detail-showcase></app-workflow-detail-showcase>
				</nz-card>
			</div>

			<div nz-col nzSpan="24">
				<nz-card nzTitle="Fragebogenübersicht">
					<app-overview-tile-showcase></app-overview-tile-showcase>
				</nz-card>
			</div>

			<div nz-col nzSpan="24">
				<app-distraction-free-wizard-showcase></app-distraction-free-wizard-showcase>
			</div>
		</nz-row>
	</nz-tab>
	<nz-tab nzTitle="Icons">
		<nz-row [nzGutter]="[16, 6]">

			<div nz-col nzSpan="24">
				<nz-card nzTitle="Icon Übersicht">
					<app-icon-showcase></app-icon-showcase>
				</nz-card>
			</div>

		</nz-row>
	</nz-tab>
	<nz-tab nzTitle="Audio">
		<nz-row [nzGutter]="[16, 6]">

			<div nz-col nzSpan="24">
				<nz-card nzTitle="Icon Übersicht">
					<app-audio-showcase></app-audio-showcase>
				</nz-card>
			</div>

		</nz-row>
	</nz-tab>
</nz-tabset>
